import React, { useEffect, memo } from "react";
import usePay from "../hooks/usePay";
import { QRCodeCanvas } from "qrcode.react";
import Modal from "./Modal";
import { openBrowser } from "../common";
import "./styles/scss/JsqPay.scss";

function App(props) {
	const { isShow, onClose } = props;
	const {
		platform,
		setPlatform,
		productList,
		product,
		setProduct,
		payType,
		setPayType,
		agree,
		setAgree,
		qrcode,
		time,
		setRefresh,
		paySucc,
	} = usePay({
		isShow,
		onClose,
		from: "JsqPay",
		platform: "yebao",
	});

	useEffect(() => {
		if (!paySucc) return;

		Modal.tips({
			icon: "succ",
			contentHead: (
				<p>
					你已成功购买
					<span style={{ color: "#5DFE97" }}>
						{productList[product]["productName"]}
					</span>
				</p>
			),
			contentBody: "请前往加速器官网下载使用加速服务",
			onOk: (c) => {
				c();
				openBrowser(
					platform === "yebao"
						? "https://www.yebaojiasu.com"
						: "https://www.akspeedy.com"
				);
			},
			okText: "前往下载",
			onCancel: (c) => {
				c();
			},
			cancelText: "取消",
		});
	}, [paySucc, productList, product, platform]);

	return (
		<Modal className="popup-jsq-pay" visible={isShow} onClose={onClose}>
			<div className="title">加速器推荐</div>
			<div className={`product-list ${platform}`}>
				<div className="product-nav">
					<button
						type="button"
						className="yebao"
						onClick={() => {
							setPlatform("yebao");
						}}
					></button>
					<button
						type="button"
						className="ak"
						onClick={() => {
							setPlatform("ak");
						}}
					></button>
				</div>
				<div className="product-box">
					{productList.map((ele, index) => {
						return (
							<div
								key={index}
								className={`product${product === index ? " active" : ""}`}
								onClick={() => {
									setProduct(index);
								}}
							>
								<div>{ele.productName}</div>
								<div>
									￥
									{platform === "yebao" ? (
										<>
											<span>{ele.productPrice}</span>/月
										</>
									) : (
										<>
											<span>
												{(ele.productPrice / ele.productDuration).toFixed(2)}
											</span>
											/小时
										</>
									)}
								</div>
								<div>
									{platform === "yebao" ? "" : "特惠价"}
									{ele.productPrice}元
								</div>
								{platform === "yebao" ? (
									<div>(原价{ele.originPrice}元)</div>
								) : (
									<div style={{ textDecoration: "none" }}>
										有效期{parseInt(ele.expiredTimeHours / 24 / 365)}年
									</div>
								)}
							</div>
						);
					})}
				</div>
			</div>
			<div className="pay-list">
				<div className="pay-type">
					{[...new Array(2)].map((ele, index) => {
						return (
							<button
								type="button"
								key={index}
								className={payType === index ? "active" : ""}
								onClick={() => {
									setPayType(index);
								}}
							>
								{ele}
							</button>
						);
					})}
				</div>
				<div className="qrcode">
					<QRCodeCanvas value={qrcode} size={96} />
					<div
						className="shadow"
						style={{ display: agree && time !== 0 ? "none" : "block" }}
					>
						{agree ? (
							<>
								二维码已过期
								<button
									type="button"
									onClick={() => {
										setRefresh((c) => !c);
									}}
								>
									刷新
								</button>
							</>
						) : (
							"请先勾选协议"
						)}
					</div>
				</div>
				<div className="pay-info">
					<div>会员类型：{productList[product]?.["productName"]}</div>
					<div>
						应付金额：
						<span>
							￥<span>{productList[product]?.["productPrice"]}</span>
						</span>
					</div>
					<div>
						<button
							type="button"
							className={agree ? "active" : ""}
							onClick={() => {
								setAgree(!agree);
							}}
						></button>
						<div
							onClick={() => {
								openBrowser(
									platform === "yebao"
										? "https://www.yebaojiasu.com/html/service-agreement.html"
										: "https://www.akspeedy.com/html/service-agreement.html"
								);
							}}
						>
							《会员服务协议》
						</div>
					</div>
				</div>
			</div>
		</Modal>
	);
}

export default memo(App);
